import { render } from "./BrowseMfg.vue?vue&type=template&id=6bec66a7&scoped=true"
import script from "./BrowseMfg.vue?vue&type=script&lang=js"
export * from "./BrowseMfg.vue?vue&type=script&lang=js"

import "./BrowseMfg.vue?vue&type=style&index=0&id=6bec66a7&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bec66a7"]])

export default __exports__